/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const toastMessageAction = data => {
  return { type: 'TOASTMESSAGEACTION', payload: data };
};
